import { useMutation } from 'react-query'

import { deleteComment } from '../../endpoints/tickets'

interface DeleteCommentParams {
    ticketId: string
    commentId: string | number
}

export const useDeleteComment = () => {
    return useMutation(
        async ({
            ticketId,
            commentId
        }: DeleteCommentParams) =>
            await deleteComment(
                ticketId,
                commentId
            )
    )
}